/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { tokens } from '@/theme';

export type NodeModeProps = {
  mode: 'maintenance' | 'standard' | 'audit';
};

type BadgeStyle = { backgroundColor: string; color: string };

// Colors matching the maintenance/audit mode banners in MaintenanceMode.tsx
const defaultBadgeColor = tokens.color.components.badge.semantic.subtle.default.color;

const badgeStyles: Record<NodeModeProps['mode'], BadgeStyle> = {
  maintenance: {
    backgroundColor: '#FEEAD1',
    color: defaultBadgeColor,
  },
  audit: {
    backgroundColor: '#fff7e6',
    color: defaultBadgeColor,
  },
  standard: {
    backgroundColor: tokens.color.components.badge.semantic.subtle.default.backgroundColor,
    color: defaultBadgeColor,
  },
};

export function NodeMode({ mode }: NodeModeProps) {
  const { t } = useMimicTranslation('nodes');
  const style = badgeStyles[mode];

  return (
    <span
      style={{
        display: 'inline-block',
        borderRadius: '50px',
        color: style.color,
        backgroundColor: style.backgroundColor,
        paddingLeft: tokens.size.size200,
        paddingRight: tokens.size.size200,
        fontSize: tokens.size.font.md,
      }}
    >
      {t(`table.${mode}`)}
    </span>
  );
}
